import React from "react";
import { Link, useNavigate } from "react-router-dom";

const PageTitle = ({ motherMenu, activeMenu, pageContent }) => {
  const navigate = useNavigate();
  let path = window.location.pathname.split("/");

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };
  

  return (
    <div className="row page-titles mx-0 align-items-center justify-content-between py-2 px-3 mb-4" style={{ borderRadius: "8px", background: "#f8f9fa", border: "1px solid #e9ecef" }}>
      <div className="d-flex align-items-center gap-3">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1 shadow-sm px-3 py-1"
          style={{
            borderRadius: "6px",
            fontWeight: "600",
            fontSize: "12px",
            transition: "all 0.2s ease-in-out",
          }}
          onClick={handleBack}
          title="Go Back to Previous Page"
        >
          <i className="fa fa-arrow-left me-1" />
          <span>Back</span>
        </button>

        <ol className="breadcrumb mb-0 py-0" style={{ background: "transparent" }}>
          <li className="breadcrumb-item active">
            <Link to={`/${path[path.length - 1]}`} style={{ textDecoration: "none" }}>{motherMenu}</Link>
          </li>
          <li className="breadcrumb-item text-dark fw-semibold">
            <Link to={`/${path[path.length - 1]}`} style={{ textDecoration: "none" }}>{activeMenu}</Link>
          </li>
        </ol>
      </div>

      {pageContent && (
        <div className="d-none d-md-block text-muted" style={{ fontSize: "12px", fontWeight: "500" }}>
          {pageContent}
        </div>
      )}
    </div>
  );
};

export default PageTitle;
